import { render, staticRenderFns } from "./PopOverSetting.vue?vue&type=template&id=3251bc8c"
import script from "./PopOverSetting.vue?vue&type=script&lang=js"
export * from "./PopOverSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports